// extracted by mini-css-extract-plugin
module.exports = {"principal":"Inicio_principal__2SwbW"};